import { getCampusLocations, getCohortTypes } from '../services/reservoir'
import { getCoursesSummary, getCourses, getStudentCalendars } from '../services/vu'
import { uniqBy } from 'lodash'
import { getProperty } from './properties'
import CourseStage from '../enums/CourseStage'
import CourseStatus from '../enums/CourseStatus'
import CourseAttemptStatus from '../enums/CourseAttemptStatus'

export const calculateDefaultCourse = (courseIdFromQueryParam = null, courseIdFromApi = null, courses = {}) => {
  // Attempt to grab the "active" course from a query param provided by the user
  if (courses[courseIdFromQueryParam]) {
    return courseIdFromQueryParam
  }

  // Attempt to grab the "active" course stored the API
  if (courses[courseIdFromApi]) {
    return courseIdFromApi
  }

  // Grab the first offer that we find as the "active" course
  for (const course in courses) {
    if (courses.hasOwnProperty(course)) {
      return course
    }
  }

  return null
}

const getOfferWeight = (cohorts, offer) => {
  const offerCohort = cohorts.find(cohort => {
    return cohort.attributes.field_test.find(cohortItem => {
      return cohortItem === offer.admissionCategory
    })
  })

  if (offerCohort && offerCohort.attributes.weight) {
    return offerCohort.attributes.weight
  }
  return -100
}

export const getActiveOffersByPriority = () => {
  //return Promise.all([getCohortTypes(), getCoursesSummary()]).then(([cohorts, coursesSummaries]) => {
  return Promise.all([getCohortTypes(), getCourses()]).then(([cohorts, coursesSummaries]) => {
    return coursesSummaries
      .filter(coursesSummary => {
        return (
          coursesSummary.studyPlanValidAttempt &&
          ((coursesSummary.courseStage === CourseStage.ADMITTED &&
            (coursesSummary.courseStatus === CourseStatus.ADMITTED ||
              coursesSummary.courseStatus === CourseStatus.LOA ||
              coursesSummary.courseStatus === CourseStatus.POTENTIALLYCOMPLETE ||
              coursesSummary.courseStatus === CourseStatus.CONDITIONALLYCOMPLETE)) ||
            (coursesSummary.courseStage === CourseStage.COMPLETED && coursesSummary.courseStatus === CourseStatus.PASS) ||
            (coursesSummary.courseStage === CourseStage.OFFERED &&
              coursesSummary.courseStudyBasisCD !== RESEARCH_STUDY_BASIS_CD &&
              ((coursesSummary.offerReleaseFlag && new Date(new Date(coursesSummary.offerLapsedDate).setHours(23, 59, 59, 999)) >= new Date() && coursesSummary.offerOutcomeCode === 'NA') ||
                (coursesSummary.offerOutcomeCode === '$ACC' || coursesSummary.offerOutcomeCode === '$DEF'))))
        )
      })
      .filter((iteratedOffer, index, self) => self.filter(offer => offer.courseCode === iteratedOffer.courseCode).length == 1)
      .map(offer => attachCourseAttemptStatus(offer))
      .sort((a, b) => {
        const aWeight = getOfferWeight(cohorts, a)
        const bWeight = getOfferWeight(cohorts, b)

        if (aWeight > bWeight) {
          return -1
        }

        if (aWeight < bWeight) {
          return 1
        }

        return 0
      })
  })
}

export const attachCourseAttemptStatus = coursesSummary => {
  let courseAttemptStatus = ''
  //TODO check the statuses as well
  if (coursesSummary.courseStage === CourseStage.OFFERED && coursesSummary.courseStatus === CourseStatus.OFFERED) {
    courseAttemptStatus = CourseAttemptStatus.Unconfirm
  } else if (coursesSummary.courseStage === CourseStage.ADMITTED && (coursesSummary.courseStatus === CourseStatus.ADMITTED || coursesSummary.courseStatus === CourseStatus.POTENTIALLYCOMPLETE)) {
    courseAttemptStatus = CourseAttemptStatus.Enrolled
  } else if (coursesSummary.courseStage === CourseStage.ADMITTED && coursesSummary.courseStatus === CourseStatus.LOA) {
    courseAttemptStatus = CourseAttemptStatus.Intermit
  } else if (
    (coursesSummary.courseStage === CourseStage.COMPLETED && coursesSummary.courseStatus === CourseStatus.PASS) ||
    (coursesSummary.courseStage === CourseStage.ADMITTED && coursesSummary.courseStatus === CourseStatus.CONDITIONALLYCOMPLETE)
  ) {
    courseAttemptStatus = CourseAttemptStatus.Completed
  }

  return Object.assign({}, coursesSummary, {
    courseAttemptStatus: courseAttemptStatus
  })
}
export const RESEARCH_STUDY_BASIS_CD = '$TIME'

export const HIGHER_EDUCATION_WINTER_BLOCK_1 = 'HWB'
export const HIGHER_EDUCATION_SUMMER_BLOCK_1 = 'HSB'
export const HIGHER_EDUCATION_SUMMER_BLOCK_2 = 'HSB2'
export const HIGHER_EDUCATION_SEMESTER_1_BLOCK_1 = 'H1B1'
export const HIGHER_EDUCATION_SEMESTER_1_BLOCK_2 = 'H1B2'
export const HIGHER_EDUCATION_SEMESTER_1_BLOCK_3 = 'H1B3'
export const HIGHER_EDUCATION_SEMESTER_1_BLOCK_4 = 'H1B4'
export const HIGHER_EDUCATION_SEMESTER_2_BLOCK_1 = 'H2B1'
export const HIGHER_EDUCATION_SEMESTER_2_BLOCK_2 = 'H2B2'
export const HIGHER_EDUCATION_SEMESTER_2_BLOCK_3 = 'H2B3'
export const HIGHER_EDUCATION_SEMESTER_2_BLOCK_4 = 'H2B4'
export const HIGHER_EDUCATION_8_WEEK_BLOCK_1 = 'H8W1'
export const HIGHER_EDUCATION_8_WEEK_BLOCK_2 = 'H8W2'
export const HIGHER_EDUCATION_8_WEEK_BLOCK_3 = 'H8W3'
export const HIGHER_EDUCATION_8_WEEK_BLOCK_4 = 'H8W4'
export const HIGHER_EDUCATION_8_WEEK_BLOCK_5 = 'H8W5'
export const HIGHER_EDUCATION_SEMESTER_1 = 'HS1'
export const HIGHER_EDUCATION_SEMESTER_2 = 'HS2'
export const HIGHER_EDUCATION_SEMESTER_4 = 'HS4'
export const HIGHER_EDUCATION_SEMESTER_3 = 'HS3'
export const HIGHER_EDUCATION_MELBOURNE_TRIMESTER_1 = 'HMT1'
export const HIGHER_EDUCATION_MELBOURNE_TRIMESTER_2 = 'HMT2'
export const HIGHER_EDUCATION_MELBOURNE_TRIMESTER_3 = 'HMT3'
export const HIGHER_EDUCATION_TRIMESTER_1 = 'HT1'
export const HIGHER_EDUCATION_TRIMESTER_2 = 'HT2'
export const HIGHER_EDUCATION_TRIMESTER_3 = 'HT3'
export const HIGHER_EDUCATION_VU_ONLINE_1 = 'HVO1'
export const HIGHER_EDUCATION_VU_ONLINE_2 = 'HVO2'
export const HIGHER_EDUCATION_VU_ONLINE_3 = 'HVO3'
export const HIGHER_EDUCATION_VU_ONLINE_4 = 'HVO4'
export const HIGHER_EDUCATION_VU_ONLINE_5 = 'HVO5'
export const HIGHER_EDUCATION_VU_ONLINE_6 = 'HVO6'

export const getDefaultLocation = locationCode => {
  return getCampusLocations().then((locations = []) => {
    const location = locations.find(location => {
      return location.attributes.field_location_code === locationCode
    })

    if (location) {
      return location.attributes.name
    }
    return null
  })
}

export const getYearsEnrolled = (units = [], sortOpposite = false) => {
  return uniqBy(units, 'unitAvailabilityYear')
    .map(unit => unit.unitAvailabilityYear)
    .sort((a, b) => {
      if (sortOpposite) {
        if (a > b) {
          return 1
        }

        if (a < b) {
          return -1
        }
      } else {
        if (a > b) {
          return -1
        }

        if (a < b) {
          return 1
        }
      }

      return 0
    })
}

export const getBlockTitle = calendarType => {
  switch (calendarType) {
    case HIGHER_EDUCATION_SEMESTER_1_BLOCK_1:
    case HIGHER_EDUCATION_SEMESTER_2_BLOCK_1:
    case HIGHER_EDUCATION_SUMMER_BLOCK_1:
    case HIGHER_EDUCATION_WINTER_BLOCK_1:
      return 'Block 1'
    case HIGHER_EDUCATION_8_WEEK_BLOCK_1:
      return '8 Week - Block 1'
    case HIGHER_EDUCATION_SEMESTER_1_BLOCK_2:
    case HIGHER_EDUCATION_SEMESTER_2_BLOCK_2:
    case HIGHER_EDUCATION_SUMMER_BLOCK_2:
      return 'Block 2'
    case HIGHER_EDUCATION_8_WEEK_BLOCK_2:
      return '8 Week - Block 2'
    case HIGHER_EDUCATION_SEMESTER_1_BLOCK_3:
    case HIGHER_EDUCATION_SEMESTER_2_BLOCK_3:
      return 'Block 3'
    case HIGHER_EDUCATION_8_WEEK_BLOCK_3:
      return '8 Week - Block 3'
    case HIGHER_EDUCATION_SEMESTER_1_BLOCK_4:
    case HIGHER_EDUCATION_SEMESTER_2_BLOCK_4:
      return 'Block 4'
    case HIGHER_EDUCATION_8_WEEK_BLOCK_4:
      return '8 Week - Block 4'
    case HIGHER_EDUCATION_8_WEEK_BLOCK_5:
      return '8 Week - Block 5'
    default:
      return ''
  }
}

export const getPeriodNames = period => {
  switch (period) {
    case HIGHER_EDUCATION_SEMESTER_1:
    case HIGHER_EDUCATION_SEMESTER_1_BLOCK_1:
    case HIGHER_EDUCATION_SEMESTER_1_BLOCK_2:
    case HIGHER_EDUCATION_SEMESTER_1_BLOCK_3:
    case HIGHER_EDUCATION_SEMESTER_1_BLOCK_4:
    case HIGHER_EDUCATION_8_WEEK_BLOCK_1:
    case HIGHER_EDUCATION_8_WEEK_BLOCK_2:
      return 'Semester 1'
    case HIGHER_EDUCATION_SEMESTER_2:
    case HIGHER_EDUCATION_SEMESTER_2_BLOCK_1:
    case HIGHER_EDUCATION_SEMESTER_2_BLOCK_2:
    case HIGHER_EDUCATION_SEMESTER_2_BLOCK_3:
    case HIGHER_EDUCATION_SEMESTER_2_BLOCK_4:
    case HIGHER_EDUCATION_8_WEEK_BLOCK_3:
    case HIGHER_EDUCATION_8_WEEK_BLOCK_4:
      return 'Semester 2'
    case HIGHER_EDUCATION_SEMESTER_3:
    case HIGHER_EDUCATION_SUMMER_BLOCK_1:
    case HIGHER_EDUCATION_SUMMER_BLOCK_2:
      return 'Summer'
    case HIGHER_EDUCATION_SEMESTER_4:
    case HIGHER_EDUCATION_WINTER_BLOCK_1:
      return 'Winter'
    case HIGHER_EDUCATION_MELBOURNE_TRIMESTER_1:
    case HIGHER_EDUCATION_TRIMESTER_1:
      return 'Trimester 1'
    case HIGHER_EDUCATION_MELBOURNE_TRIMESTER_2:
    case HIGHER_EDUCATION_TRIMESTER_2:
      return 'Trimester 2'
    case HIGHER_EDUCATION_MELBOURNE_TRIMESTER_3:
    case HIGHER_EDUCATION_TRIMESTER_3:
      return 'Trimester 3'
    case HIGHER_EDUCATION_VU_ONLINE_1:
      return 'Study Period 1'
    case HIGHER_EDUCATION_VU_ONLINE_2:
      return 'Study Period 2'
    case HIGHER_EDUCATION_VU_ONLINE_3:
      return 'Study Period 3'
    case HIGHER_EDUCATION_VU_ONLINE_4:
      return 'Study Period 4'
    case HIGHER_EDUCATION_VU_ONLINE_5:
      return 'Study Period 5'
    case HIGHER_EDUCATION_VU_ONLINE_6:
      return 'Study Period 6'
    case HIGHER_EDUCATION_8_WEEK_BLOCK_5:
      return '8 Week - Block 5'
    default:
      return period
  }
}

export const getCalendarTypeName = calendarType => {
  const periodName = getPeriodNames(calendarType)

  const blockTitle = getBlockTitle(calendarType)
  if (blockTitle && blockTitle !== periodName) {
    return periodName + ' - ' + blockTitle
  }

  return periodName
}

/**
 * @return {Array<string>}
 */
export const getSupportedCalendarTypes = () =>
  [].concat(
    getVuOnlineStudyPeriodCalendarTypes(),
    getSemester1CalendarTypes(),
    getSemester2CalendarTypes(),
    getSummerCalendarTypes(),
    getWinterCalendarTypes(),
    getMelbourneTrimesters(),
    getSydneyTrimesters(),
    getDualInstanceBlockWeek5CalendarTypes()
  )

/**
 * @return {Array<string>}
 */
export const getMelbourneTrimesters = () => [HIGHER_EDUCATION_MELBOURNE_TRIMESTER_1, HIGHER_EDUCATION_MELBOURNE_TRIMESTER_2, HIGHER_EDUCATION_MELBOURNE_TRIMESTER_3]

/**
 * @return {Array<string>}
 */
export const getSydneyTrimesters = () => [HIGHER_EDUCATION_TRIMESTER_1, HIGHER_EDUCATION_TRIMESTER_2, HIGHER_EDUCATION_TRIMESTER_3]

/**
 * @param {string} calenderType
 * @return {string}
 */
export const getPeriodByCalendarType = calenderType => {
  if (getSemester1CalendarTypes().find(semester1CalendarType => semester1CalendarType === calenderType)) {
    return HIGHER_EDUCATION_SEMESTER_1
  }

  if (getSemester2CalendarTypes().find(semester2CalendarType => semester2CalendarType === calenderType)) {
    return HIGHER_EDUCATION_SEMESTER_2
  }

  if (getSummerCalendarTypes().find(summerCalendarType => summerCalendarType === calenderType)) {
    return HIGHER_EDUCATION_SEMESTER_3
  }

  if (getWinterCalendarTypes().find(winterCalendarType => winterCalendarType === calenderType)) {
    return HIGHER_EDUCATION_SEMESTER_4
  }

  return calenderType
}

/**
 * @return {Array<string>}
 */
export const getVuOnlineStudyPeriodCalendarTypes = () => [
  HIGHER_EDUCATION_VU_ONLINE_1,
  HIGHER_EDUCATION_VU_ONLINE_2,
  HIGHER_EDUCATION_VU_ONLINE_3,
  HIGHER_EDUCATION_VU_ONLINE_4,
  HIGHER_EDUCATION_VU_ONLINE_5,
  HIGHER_EDUCATION_VU_ONLINE_6
]

/**
 * @return {Array}
 */
export const getSemester1CalendarTypes = () => [HIGHER_EDUCATION_SEMESTER_1].concat(getSemester1BlockModelCalendarTypes(), getSemester1DualInstanceBlockModelCalendarTypes())

/**
 * @return {Array}
 */
export const getSemester1BlockModelCalendarTypes = () => [
  HIGHER_EDUCATION_SEMESTER_1_BLOCK_1,
  HIGHER_EDUCATION_SEMESTER_1_BLOCK_2,
  HIGHER_EDUCATION_SEMESTER_1_BLOCK_3,
  HIGHER_EDUCATION_SEMESTER_1_BLOCK_4
]

/**
 * @return {Array}
 */
export const getSemester1DualInstanceBlockModelCalendarTypes = () => [HIGHER_EDUCATION_8_WEEK_BLOCK_1, HIGHER_EDUCATION_8_WEEK_BLOCK_2]

/**
 * @return {Array}
 */
export const getSemester2CalendarTypes = () => [HIGHER_EDUCATION_SEMESTER_2].concat(getSemester2BlockModelCalendarTypes(), getSemester2DualInstanceBlockModelCalendarTypes())

/**
 * @return {Array}
 */
export const getSemester2BlockModelCalendarTypes = () => [
  HIGHER_EDUCATION_SEMESTER_2_BLOCK_1,
  HIGHER_EDUCATION_SEMESTER_2_BLOCK_2,
  HIGHER_EDUCATION_SEMESTER_2_BLOCK_3,
  HIGHER_EDUCATION_SEMESTER_2_BLOCK_4
]

/**
 * @return {Array}
 */
export const getSemester2DualInstanceBlockModelCalendarTypes = () => [HIGHER_EDUCATION_8_WEEK_BLOCK_3, HIGHER_EDUCATION_8_WEEK_BLOCK_4]

/**
 * @return {Array}
 */
export const getSummerCalendarTypes = () => [HIGHER_EDUCATION_SEMESTER_3].concat(getSummerBlockModelCalendarTypes())

/**
 * @return {Array}
 */
export const getSummerBlockModelCalendarTypes = () => [].concat(getSummerBlockModelOpeningCalendarTypes(), getSummerBlockModelClosingCalendarTypes())

/**
 * @return {Array<string>}
 */
export const getSummerBlockModelOpeningCalendarTypes = () => [HIGHER_EDUCATION_SUMMER_BLOCK_1]

/**
 * @return {Array<string>}
 */
export const getSummerBlockModelClosingCalendarTypes = () => [HIGHER_EDUCATION_SUMMER_BLOCK_2]

/**
 * @return {Array}
 */
export const getDualInstanceBlockWeek5CalendarTypes = () => [HIGHER_EDUCATION_8_WEEK_BLOCK_5]

/**
 * @return {Array}
 */
export const getWinterCalendarTypes = () => [HIGHER_EDUCATION_SEMESTER_4].concat(getWinterBlockModelCalendarTypes())

/**
 * @return {Array}
 */
export const getWinterBlockModelCalendarTypes = () => [HIGHER_EDUCATION_WINTER_BLOCK_1]

export const getBlockModelCalendarTypes = () =>
  [].concat(
    getSemester1BlockModelCalendarTypes(),
    getSemester2DualInstanceBlockModelCalendarTypes(),
    getSemester1DualInstanceBlockModelCalendarTypes(),
    getDualInstanceBlockWeek5CalendarTypes(),
    getSemester2BlockModelCalendarTypes(),
    getSummerBlockModelCalendarTypes(),
    getWinterBlockModelCalendarTypes()
  )

/**
 * @param {String} courseAttemptStatus
 * @param {String} sectorCode
 * @return {Boolean}
 */
export const isBlockedStudentConfiguration = (courseAttemptStatus, sectorCode) => {
  return isBlockedStudentCourseAttemptStatus(courseAttemptStatus) || isBlockedStudentSectorCode(sectorCode)
}

/**
 * @param {String} courseAttemptStatus
 * @return {Boolean}
 */
export const isBlockedStudentCourseAttemptStatus = courseAttemptStatus => {
  switch (courseAttemptStatus) {
    // case 'INTERMIT':
    case 'COMPLETED':
      return true
    default:
      return false
  }
}

/**
 * @param {String} sectorCode
 * @return {Boolean}
 */
export const isBlockedStudentSectorCode = sectorCode => {
  switch (sectorCode) {
    case 'VET':
      return true
    default:
      return false
  }
}

export const getEnrolUrl = (commencingStudent, course, completedEnrolment, enrolmentYearsAsString, courseAttemptStatus, offers) => {
  const offerAcceptanceUrl = ``
  const enrolmentUrl = `${getProperty('enrolUrl')}?courseId=${course}`
  const manageEnrolmentUrl = enrolmentYearsAsString !== '' ? `${getProperty('manageEnrolUrl')}/${getEnrollableYears(enrolmentYearsAsString)[0]}?courseId=${course}` : enrolmentUrl

  if (courseAttemptStatus === CourseAttemptStatus.Unconfirm && offers.length > 0) {
    return enrolmentUrl
  }
  if (commencingStudent && !completedEnrolment) {
    return enrolmentUrl
  }

  return manageEnrolmentUrl
}

export const getEnrollableYears = enrolmentYearsAsString => {
  let enrollableYears = enrolmentYearsAsString ? enrolmentYearsAsString.replace(/\s+/g, '').split(',') : new Date().getFullYear()

  return enrollableYears.sort((a, b) => {
    if (a > b) {
      return -1
    }

    if (a < b) {
      return 1
    }

    return 0
  })
}

export const getNextBlock = currentBlock => {
  let blocks = [
    //Summer (Jan)
    HIGHER_EDUCATION_SUMMER_BLOCK_1,
    //Semester1
    HIGHER_EDUCATION_SEMESTER_1_BLOCK_1,
    HIGHER_EDUCATION_SEMESTER_1_BLOCK_2,
    HIGHER_EDUCATION_SEMESTER_1_BLOCK_3,
    HIGHER_EDUCATION_SEMESTER_1_BLOCK_4,
    //Winter
    HIGHER_EDUCATION_WINTER_BLOCK_1,
    //Semester2
    HIGHER_EDUCATION_SEMESTER_2_BLOCK_1,
    HIGHER_EDUCATION_SEMESTER_2_BLOCK_2,
    HIGHER_EDUCATION_SEMESTER_2_BLOCK_3,
    HIGHER_EDUCATION_SEMESTER_2_BLOCK_4,
    //Summer (Dec)
    HIGHER_EDUCATION_SUMMER_BLOCK_2
  ]

  let index = blocks.indexOf(currentBlock)

  if (index == -1) {
    //current block not found
    return null
  }

  if (index == blocks.length - 1) {
    //last unit of the year!
    return null
  }

  return blocks[index + 1]
}

/*
  Returns array containing the unit and any 'virtual units'
  - Virtual units are placeholder units used to represent units with CP>12
  eg1. A unit with a CP of 24 => [Unit, VirtualUnit]
  eg2. A unit with CP of 36 => [Unit, VirtualUnit, VirtualUnit]
*/
export const getVirtualUnits = unit => {
  let calendarTypes = calculateCalendarTypesForCreditPoints(unit.unitAvailabilityStudyPeriodCode, unit.unitCreditPoints)
  return calendarTypes.map(calType => {
    const unitClone = { ...unit }
    unitClone.unitAvailabilityStudyPeriodCode = calType
    unitClone.virtual = true
    return unitClone
  })
}

export const calculateCalendarTypesForCreditPoints = (startCalendarType, creditPoints) => {
  let calendarPeriodCount = creditPoints / 12
  let currentCalendarType = startCalendarType

  return new Array(calendarPeriodCount)
    .fill(null)
    .map(() => {
      if (currentCalendarType != null) {
        let calType = currentCalendarType
        currentCalendarType = getNextBlock(currentCalendarType)
        if (currentCalendarType != null) {
          return calType
        }
      }
      return null
    })
    .filter(item => item != null)
}

export const addVirtualUnits = units => {
  let virtualUnitSet = units
  units.forEach(unit => {
    let virtualUnits = getVirtualUnits(unit)
    virtualUnitSet.push(...virtualUnits)
  })
  return virtualUnitSet
}

export const removeVirtualUnitsOverlappingRealUnits = enrolledUnits => {
  return enrolledUnits.filter(enrolledUnit => {
    if (enrolledUnit.virtual !== true) {
      return true
    }

    let virtualUnitOverlapsRealUnit =
      enrolledUnits.filter(aUnit => aUnit.virtual !== true && aUnit.unitAvailabilityStudyPeriodCode == enrolledUnit.unitAvailabilityStudyPeriodCode).length > 0
    return !virtualUnitOverlapsRealUnit
  })
}

export const isEligibleToEnrolNow = (course, isSanctionsApplied) => {
  return (
    !course.isVet &&
    course.courseStage === CourseStage.ADMITTED &&
    course.isSelfManagedCourse &&
    (course.courseStatus === CourseStatus.POTENTIALLYCOMPLETE || course.courseStatus === CourseStatus.ADMITTED || course.courseStatus === CourseStatus.LOA) &&
    course.courseStudyBasisCD !== RESEARCH_STUDY_BASIS_CD &&
    !isSanctionsApplied &&
    course.isEnrolOpen
  )
}

export const isEligibleToAcceptOffer = course => {
  return !course.isVet && course.courseStage === CourseStage.OFFERED && course.courseStatus === CourseStatus.OFFERED && course.courseStudyBasisCD !== RESEARCH_STUDY_BASIS_CD
}

export const hasSanctions = (personalDetails, courseId) => {
  let sanctions = personalDetails.studentSanctions.filter(
    sanction =>
      (sanction.holdCd === '$PE' || sanction.holdCd === '$PSPA') &&
      (!sanction.studyPackageCode || sanction.studyPackageCode === courseId) &&
      sanction.expiryDateValid &&
      sanction.effectiveDateValid
  )

  if (sanctions.length > 0) {
    return true
  } else {
    return false
  }
}

export const getEnrolSanctionsType = (sanctions, courseId) => {
  if (!Array.isArray(sanctions) || sanctions.length === 0 || !courseId) {
    return []
  }

  const enrolSanctions = sanctions.filter(
    sanction =>
      (sanction.holdCd === '$PE' || sanction.holdCd === '$PSPA') &&
      (!sanction.studyPackageCode || sanction.studyPackageCode === courseId) &&
      sanction.expiryDateValid &&
      sanction.effectiveDateValid
  )

  const sanctionTypes = Array.from(new Set(enrolSanctions.map(s => s.sanctionType)))

  return sanctionTypes
}